module.exports = __webpack_public_path__ + "img/google-play-badge-en.95ff5c38.png";